import { render } from "./MakePredictionsSoccer.vue?vue&type=template&id=34ef379f&scoped=true"
import script from "./MakePredictionsSoccer.vue?vue&type=script&lang=js"
export * from "./MakePredictionsSoccer.vue?vue&type=script&lang=js"

import "./MakePredictionsSoccer.vue?vue&type=style&index=0&id=34ef379f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ef379f"]])

export default __exports__